export enum StorageKeys {
  IS_DARK_MODE = "isDarkMode",
  COLOR_SCHEME = "(prefers-color-scheme: dark)",
  DARK_MODE = "dark-mode",
}
